import _ from 'lodash'

const state = {
    // These loadings are cleared on route change
    // and are identified by originId + key.
    // {originId, key}
    loadings: [],

    // These loadings are kept on route change
    // and are identified by key.
    // originId is kept for reference only.
    // {originId, key}
    globalLoadings: []
}

const getters = {
    loadings (state) {
        return state.loadings
    },

    globalLoadings (state) {
        return state.globalLoadings
    }
}

const mutations = {
    loadingAdd (state, loading) {
        if (!_.find(state.loadings, { originId: loading.originId, key: loading.key })) {
            state.loadings.push(loading)
        }
    },

    loadingRemove (state, loading) {
        let index = _.findIndex(state.loadings, { originId: loading.originId, key: loading.key })

        if (index >= 0) {
            state.loadings.splice(index, 1)
        }
    },

    clearLoadings (state) {
        state.loadings = []
    },

    globalLoadingAdd (state, loading) {
        if (!_.find(state.globalLoadings, { key: loading.key })) {
            state.globalLoadings.push(loading)
        }
    },

    globalLoadingRemove (state, loading) {
        let index = _.findIndex(state.globalLoadings, { key: loading.key })

        if (index >= 0) {
            state.globalLoadings.splice(index, 1)
        }
    }
}

const actions = {
    loadingAdd ({ commit }, loading) {
        commit('loadingAdd', loading)
    },

    loadingRemove ({ commit }, loading) {
        commit('loadingRemove', loading)
    },

    clearLoadings ({ commit }) {
        commit('clearLoadings')
    },

    globalLoadingAdd ({ commit }, loading) {
        commit('globalLoadingAdd', loading)
    },

    globalLoadingRemove ({ commit }, loading) {
        commit('globalLoadingRemove', loading)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
